import { Alert, Drawer } from 'antd';
import { Skeleton } from '../../../shared/components/Skeleton';
import { SkeletonRegion } from '../../../shared/components/SkeletonRegion';
import { useAdapterCatalogue } from '../hooks/use-adapter-catalogue';
import { useIntegrationSheet } from '../hooks/use-integration-sheet';
import { IntegrationForm } from './IntegrationForm';

interface IntegrationSheetProps {
  /** The adapter being installed, or undefined when editing `integrationId`. */
  adapterKey: string | undefined;
  integrationId: string | undefined;
  onClose: () => void;
}

/** Install a GPS adapter, or edit an installation: the adapter's own fields, a connection test before saving, and secrets that are write-only. */
export function IntegrationSheet({ adapterKey, integrationId, onClose }: IntegrationSheetProps) {
  const catalogue = useAdapterCatalogue();
  const sheet = useIntegrationSheet({ catalogue, adapterKey, integrationId, onDone: onClose });

  return (
    <Drawer open onClose={onClose} title={integrationId ? 'Edit integration' : 'Install integration'} size={480}>
      {sheet.isLoading && <SheetSkeleton />}
      {!sheet.isLoading && !sheet.adapter && (
        <Alert
          type="error"
          showIcon
          title="This integration's adapter isn't available"
          description="It may not be part of this release, or can't be installed on this deployment."
        />
      )}
      {!sheet.isLoading && sheet.adapter && <IntegrationForm sheet={sheet} adapter={sheet.adapter} isEdit={Boolean(integrationId)} />}
    </Drawer>
  );
}

function SheetSkeleton() {
  return (
    <SkeletonRegion label="Loading the integration" className="flex flex-col gap-5">
      <Skeleton className="h-10 w-1/2" />
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-full" />
    </SkeletonRegion>
  );
}
